module.exports = __webpack_public_path__ + "static/media/photo269.c59ba864.jpg";